<template>
    <v-layout>
        <v-flex xs12>
            <v-card flat>
                <v-card-text>
                    <v-layout row v-if="loading">
                        <v-flex xs12>
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="!loading">
                        <v-flex xs6 class="pa-2">
                            <v-autocomplete
                                    :items="scopedCombinations.equipment_type"
                                    :label="'Equipment Type'|translate"
                                    v-model="payload.filters.equipment_type"
                                    placeholder="All"
                                    no-data-text="No data matching current filters"
                                    clearable
                            ></v-autocomplete>
                            <v-autocomplete
                                    :items="scopedCombinations.equipment_name"
                                    :label="'Equipment Name'|translate"
                                    v-model="payload.filters.equipment_name"
                                    placeholder="All"
                                    no-data-text="No data matching current filters"
                                    clearable
                            ></v-autocomplete>
                            <v-autocomplete
                                    :items="scopedCombinations.sensor_name"
                                    :label="'Sensor Name'|translate"
                                    v-model="payload.filters.sensor_name"
                                    placeholder="All"
                                    no-data-text="No data matching current filters"
                                    required
                                    clearable
                            ></v-autocomplete>
                            <v-autocomplete
                                    :items="scopedCombinations.floor"
                                    :label="'Floor'|translate"
                                    v-model="payload.filters.floor"
                                    placeholder="All"
                                    no-data-text="No data matching current filters"
                                    clearable
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 class="pa-2">
                            <v-switch color="success" class="ml-2"
                                      v-model="onOnly"
                                      :label="'On Only'|translate"
                            ></v-switch>
                            <v-select
                                    :items="aggFreq"
                                    :label="'Time Agg Frequency'|translate"
                                    v-model="agg"
                                    clearable
                            ></v-select>
                            <v-select
                                    :items="aggOpps"
                                    :label="'Time Agg Operation'|translate"
                                    v-model="agg_op"
                                    v-if="agg"
                            ></v-select>
                            <v-switch color="success" v-if="agg&&agg_op==='sum'"
                                      v-model="divide_by_sf"
                                      :label="'Divide by sampling freq'|translate"
                            ></v-switch>
                            <v-select
                                    :items="seriesReturnTypes"
                                    :label="'Return data as'|translate"
                                    v-model="seriesReturnType"
                            ></v-select>
                            <v-text-field v-if="seriesReturnType!=='one series per sensor'" :label="'Series name'|translate"  v-model="seriesReturnName"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text v-show="!payload.filters.sensor_name&&!payload.filters.equipment_name">
                    <v-alert
                            :value="true"
                            type="info"
                    >
                        {{'Please select a Sensor Name or an Equipment Name'|translate}}
                    </v-alert>
                </v-card-text>
            </v-card>
        </v-flex>


    </v-layout>
</template>

<script>
    import {sortFloors} from '@/helper'

    export default {
        name: 'QueryBuilder',
        components: {},
        props: {
            callback: {type: Function, default: null},
            value: {type: Object, default: ()=>{return{
                    'filters': {
                    },
                    pipeline:[],
                }}},
        },
        computed: {
            scopedCombinations() {
                    let scopedCombo = {}
                    for (let filterName of this.filterNames) {
                        if (Object.keys(this.payload.filters).length === 0 || (Object.keys(this.payload.filters).length === 1 && this.payload.filters[filterName])) {
                            scopedCombo[filterName] = [...new Set(this.combinations.map(x => x[filterName]))].sort()
                        } else {
                            let otherFilters = this.filterNames.filter(x => x !== filterName && this.payload.filters[x])
                            scopedCombo[filterName] = [...new Set(this.combinations.filter((x) => {
                                for (let otherFilter of otherFilters) {
                                    if (x[otherFilter] !== this.payload.filters[otherFilter]) {
                                        return false
                                    }
                                }
                                return true
                            }).map(x => x[filterName]))].sort()
                        }
                    }
                    if (scopedCombo.floor) {
                        scopedCombo.floor = sortFloors(scopedCombo.floor.filter(x => x && x !== ""))
                    }
                    return scopedCombo
                }
        },
        watch: {
            payload: {
                handler() {
                    this.save()
                },
                deep: true,
                immediate: true,
            },
            onOnly(){
                this.save()
            },agg(){
                this.save()
            },agg_op(){
                this.save()
            },divide_by_sf(){
                this.save()
            },seriesReturnType(){
                this.save()
            },seriesReturnName(){
                this.save()
            },
        },
        data: () => ({
            loading: true,
            combinations: [],
            filterNames: ["sensor_name", "equipment_type", "equipment_name", "floor"],
            aggFreq: ["H", "D", "W", "M", "Y"],
            aggOpps: ["sum", "mean", "count", "min", "max"],
            seriesReturnTypes: ["one series per sensor","sum", "mean", "count", "min", "max"],
            filterOpp: ["eq", "neq", "gt", "ge", "lt", "le"],
            payload:{
                'filters': {
                },
                pipeline:[],
            },
            defaultPayload:{
                'filters': {
                },
                pipeline:[],
            },
            onOnly:false,
            agg:null,
            agg_op:"sum",
            divide_by_sf:true,
            seriesReturnType:"one series per sensor",
            seriesReturnName:"Time series 1"

        }),
        methods: {
            save(){
                if (this.payload.filters.sensor_name||this.payload.filters.equipment_name) {
                    let payload = JSON.parse(JSON.stringify(this.payload))
                    if (this.onOnly) {
                        payload.pipeline.push(
                            {
                                "type": "filter",
                                "filter_op": "eq",
                                "filter_by": "* - on",
                                "filter_value": 1,
                            }
                        )
                    }
                    if (this.agg) {
                        payload.pipeline.push({
                            "type": "agg",
                            "agg": this.agg,
                            "agg_op": this.agg_op,
                            "divide_by_sf": this.divide_by_sf
                        })
                    }
                    if (this.seriesReturnType !== 'one series per sensor') {
                        payload.pipeline.push({
                            "type": "agg_h",
                            "agg_op": this.seriesReturnType,
                            "name": this.seriesReturnName
                        })
                    }
                    this.$emit('input', payload)
                } else {
                    this.$emit('input', null)
                }
            }

        },
        mounted() {
            let combinations = this.$store.state.pointsListStore.pointsList.points_list.map(sensor => {
                return {
                    sensor_name: sensor.sensor_name,
                    equipment_name: sensor.equipment_name,
                    equipment_type: this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_type,
                    floor: this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].floor,
                }
            })
            this.combinations = JSON.parse(JSON.stringify(combinations))
            this.loading = false
        },

    }
</script>